const version = 1.4;
const title = `Version ${version} Available.`;
const releaseNote = "RELEASE NOTE";
const messages = [
  "By powering up with push holding the sequence knob, you can change the MIDI channel using in MIDI note control from ch 1 to 16.",
  "Once MIDI CH EDIT displays, you can chose a channel by rotating the sequence knob and select it by pushing the knob.",
  "Changed MIDI channel is saved automatically.",
];
const updateText = "Ready To Install";
const binaryFilePath =
  "https://cdn.shopify.com/s/files/1/1557/5869/files/Tararira_WebUpdate_V1.4_a2111359-0a0f-414e-8aa4-0fa3ac7ea2dd.bin?v=1650268143";

$(function () {
  function setVersions() {
    const $version = $("#page-tararira-update .version");
    if ($version.length > 0) {
      $version.append(`<h1>${title}</h1>`);
      $version.append(`<h2>${releaseNote}</h2>`);
      messages.forEach((message) => {
        $version.append(`<h3>${message}</h3>`);
      });
    }
    const $page2header = $("#page-tararira-update #page-2 h2");
    $page2header.text(updateText);
  }
  function setColor() {
    $("body").addClass("page-tararira");
  }
  if ($("#page-tararira-update").length > 0) {
    setColor();
    setVersions();
  }

  if ($("#page-tararira-manual").length > 0) {
    $("body").addClass("page-tararira-manual");
  }

  if ($("#page-repair-wizzard").length > 0) {
    $("body").addClass("page-repair-wizzard");
  }
  function toggleManualScaleModes() {
    const churchMode = "church-mode";
    const tonal = "tonal";
    const nonTonal = "non-tonal";
    $("#page-tararira-manual #mode-scale-sfx-knob .scale .selector-wrapper .selector-button").on(
      "click",
      function () {
        let mode;
        if ($(this).hasClass(churchMode)) {
          mode = churchMode;
        } else if ($(this).hasClass(tonal)) {
          mode = tonal;
        } else if ($(this).hasClass(nonTonal)) {
          mode = nonTonal;
        } else {
          return;
        }
        $(
          `#page-tararira-manual #mode-scale-sfx-knob .scale .selector-wrapper .selector-button`,
        ).removeClass("selected");
        $(
          `#page-tararira-manual #mode-scale-sfx-knob .scale .selector-wrapper .selector-button.${mode}`,
        ).addClass("selected");
        $(`#page-tararira-manual #mode-scale-sfx-knob .scale .frame .wrapper`).removeClass("on");
        $(`#page-tararira-manual #mode-scale-sfx-knob .scale .frame .wrapper.${mode}`).addClass(
          "on",
        );
      },
    );
  }

  function forRepaierWizzard() {
    const $section1 = $("#section-1");
    const $section2 = $("#section-2");
    function forSection1() {
      const $start = $section1.find("section.start");
      const $questions = $section1.find("section.questions");
      const $navToForm = $section1.find("section.nav-form.toggle");
      const $navToSection2 = $section1.find("section.nav-to-section-2");
      $questions.find("button.yes").on("click", () => {
        const $currentQuestion = $questions.find(".question.on");
        const $nextQuestion = $currentQuestion.next();
        if ($nextQuestion[0]) {
          toggle($currentQuestion, $nextQuestion);
        } else {
          toggle($questions, $navToForm);
        }
      });

      $start.find("button.ok").on("click", () => toggle($start, $questions));

      $questions.find("button.no").on("click", () => toggle($questions, $navToSection2));

      $navToSection2.find("button.go-section-2").on("click", () => toggle($section1, $section2));
      $navToForm.find(".ok").on("click", () => {
        window.location.href = "https://banananaeffects.com/pages/repair-service-warranty-form";
      });
    }

    function forSection2() {
      const $questions = $section2.find("section.questions");
      const $navToForm = $section2.find("section.nav-form");
      const $navToRepair = $section2.find("section.nav-repair-page");

      $questions.find("button.yes").on("click", () => {
        const $currentQuestion = $questions.find(".question.on");
        const $nextQuestion = $currentQuestion.next();
        if ($nextQuestion[0]) {
          toggle($currentQuestion, $nextQuestion);
        } else {
          toggle($questions, $navToForm);
        }
      });
      $questions.find("button.no").on("click", () => toggle($questions, $navToRepair));
      $navToRepair.find(".ok").on("click", () => {
        const $selector = $navToRepair.find("select");
        const value = $selector.val();
        if (value === "tararira") {
  window.location.href =
    "https://banananaeffects.com/products/tararira-circuit-board-replacement-service";
} else if (value === "quimera") {
  window.location.href =
    "https://banananaeffects.com/products/repair-service-quimera-internal-board-replacement";
} else {
  window.location.href =
    "https://banananaeffects.com/products/repair-service-mini-series-internal-board-replacement";
}

      });

      $navToForm.find(".ok").on("click", () => {
        window.location.href = "https://banananaeffects.com/pages/repair-service-form";
      });
    }
    forSection1();
    forSection2();
  }

  forRepaierWizzard();

  toggleManualScaleModes();
  new SmoothScroll(
    '#page-tararira-manual #index a[href*="#"], #page-tararira-manual #go-to-index a[href*="#"]',
    {
      speed: 20,
      easing: "linear",
      offset: 80,
      updateURL: false,
    },
  );
});

function toggle($willDismiss, $willShow, time = 100) {
  $willDismiss.fadeOut(time);
  setTimeout(() => {
    $willShow.addClass("on");
    $willShow.removeClass("off");
    $willDismiss.removeClass("on");
    $willDismiss.addClass("off");
  }, time);
}
